<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "HomePage"
})
</script>

<template>
  <div class="p-4">
    <router-link to="/check-in" class="btn btn-lg btn-primary w-100">Check In</router-link>
    <div class="p-4"></div>
    <router-link to="/check-out" class="btn btn-lg btn-success w-100">Check Out</router-link>
    <div class="p-4"></div>
    <router-link to="/finish" class="btn btn-lg btn-warning w-100">Finish Truck</router-link>

  </div>
</template>

<style scoped>

</style>